import React from 'react';
import { scoreColor, scoreBand } from './diagnosticHelpers';

const SummaryCard = ({ variant, label, score, band, subtitle, note, accent }) => (
  <div className={`dxr-summary-card ${variant}`}>
    <div className="dxr-summary-top">
      <span className="dxr-summary-label">{label}</span>
      {band && (
        <span className="dxr-summary-band" style={{ color: accent, background: `${accent}14` }}>{band}</span>
      )}
    </div>
    <div className="dxr-summary-score" style={{ color: accent }}>
      {score != null ? `${Math.round(score)}%` : '—'}
    </div>
    <p className="dxr-summary-subtitle">{subtitle}</p>
    {note && <p className="dxr-summary-note">{note}</p>}
  </div>
);

// Section 1 — Overall Assessment Summary.
// Knowledge is the primary academic indicator; Behaviour and ERI sit beside it,
// with ERI clearly framed as a guidance indicator (not a verdict).
const SummaryTriad = ({ knowledgeScore, behaviourScore, eriScore }) => {
  return (
    <div className="dxr-summary-grid">
      <SummaryCard
        variant="knowledge primary"
        label="Knowledge Score"
        score={knowledgeScore}
        band={knowledgeScore != null ? scoreBand(knowledgeScore) : null}
        accent={scoreColor(knowledgeScore)}
        subtitle="Knowledge demonstrated through assessment performance — based on correct answers, question difficulty and topic accuracy."
      />
      <SummaryCard
        variant="behaviour"
        label="Behaviour Score"
        score={behaviourScore}
        band={behaviourScore != null ? scoreBand(behaviourScore) : null}
        accent={scoreColor(behaviourScore)}
        subtitle="Learning behaviour observed during the assessment — combines time-pressure stability, efficiency, risk strategy and focus."
      />
      <SummaryCard
        variant="eri"
        label="Employability Readiness Index (ERI)"
        score={eriScore}
        band={eriScore != null ? scoreBand(eriScore) : null}
        accent={scoreColor(eriScore)}
        subtitle="Overall readiness indicator combining assessment performance and behavioural observations."
        note="ERI is a guidance indicator based on assessment performance and behavioural observations. It should not be interpreted as a direct measure of employability."
      />
    </div>
  );
};

export default SummaryTriad;
